export default "__VITE_ASSET__7TvhKype__"